<template>
  <div
    class="email-textarea-container"
    :class="{
      'input-error': error,
    }"
    @click="setFocus"
  >
    <EmailTicket
      v-for="(elem, idx) in emails"
      :key="idx"
      :email="elem.email"
      :valid="elem.valid"
      class="email-textarea-ticket"
      @remove-email="removeEmail(elem.email)"
    />
    <input
      ref="emailInput"
      v-model="emailInput"
      :placeholder="placeholder"
      type="text"
      class="email-textarea-input"
      @paste="handlePaste"
      @keypress="isValid($event)"
    />
  </div>
</template>

<script>
  import EmailTicket from '@/components/ui/EmailTicket';
  import emailValidation from '@/utils/simple-email-validation';
  import inputErrors from '@/utils/mixins/input-errors';

  export default {
    name: 'EmailTextarea',
    components: { EmailTicket },
    mixins: [inputErrors],
    props: {
      emails: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        emailInput: '',
      };
    },
    computed: {
      placeholder() {
        return this.emails.length
          ? ''
          : this.$t('Enter email addresses, separated by commas or spaces');
      },
    },
    methods: {
      removeEmail(email) {
        let updatedEmails = this.emails.filter((elem) => elem.email !== email);
        this.$emit('update-emails', updatedEmails);
      },
      addEmail(email) {
        let isEmailValid = emailValidation(email);
        let updatedEmails = [...this.emails, { email: email, valid: isEmailValid }];
        this.$emit('update-emails', updatedEmails);
      },
      addEmails(emails) {
        let newEmails = [];
        emails.split(/,| /).forEach((email) => {
          let isEmailValid = emailValidation(email);
          newEmails = [...newEmails, { email: email, valid: isEmailValid }];
        });
        this.$emit('update-emails', [...this.emails, ...newEmails]);
      },
      isValid(evt) {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        // Space and comma
        if (charCode === 32 || charCode === 44) {
          evt.preventDefault();
          this.addEmail(this.emailInput);
          this.emailInput = '';
        } else {
          return true;
        }
      },
      setFocus() {
        this.$refs.emailInput.focus();
      },
      handlePaste(evt) {
        this.addEmails(evt.clipboardData.getData('text'));
        evt.preventDefault();
      },
    },
  };
</script>
<style lang="scss">
  @import 'src/styles/components/email-textarea';
</style>
